












import VimeoPlayerComponent from './VimeoPlayerComponent.vue';
import YoutubePlayerComponent from './YoutubePlayerComponent.vue';

import ConsentService from '@/shared/services/consent-service';
import {defineComponent, ref, onMounted} from "@vue/composition-api";

export default defineComponent({
  name: 'VideoPlayerWidget',
  components: {
    VimeoPlayerComponent,
    YoutubePlayerComponent
  },
  props: {
    id: {type: String, required: true},
    playerType: {type: [Number, String]},
    consentHtml: {type: String}
  },
  setup: () => {
    const minCookieLevel = 4;
    const disabled = ref(true);

    function checkCookieConsent(min: number): boolean {
      return ConsentService.validate(min);
    }

    function recheckAllowedToViewVideo() {
      disabled.value = !allowedToViewVideo();
    }

    function allowedToViewVideo(): boolean {
      return checkCookieConsent(minCookieLevel);
    }

    onMounted(() => {
      recheckAllowedToViewVideo();
      window.dispatchEvent(new Event('initializeConsentLinks'));
      window.addEventListener('consentLevelUpdate', function () {
        recheckAllowedToViewVideo();
      });
    })

    return {
      disabled
    }
  }
})
